import Vue from 'vue'
import './plugins/axios'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import VueMoment from 'vue-moment'
import moment from 'moment'
// var moment = require('moment')
// require('moment/locale/th')
Vue.use(VueMoment, {
  moment
})

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// Initialize Firebase
let app = ''
import firebase from 'firebase/app' // Storage
import 'firebase/storage'
import 'firebase/auth'
var config = {
  apiKey: 'AIzaSyBDkOS6vu9oK682RwvD5hnIvMZPmDiCONs',
  authDomain: 'farmerspace-techfarm.firebaseapp.com',
  databaseURL: 'https://farmerspace-techfarm.firebaseio.com',
  projectId: 'farmerspace-techfarm',
  storageBucket: 'farmerspace-techfarm.appspot.com',
  messagingSenderId: '348816337784'
}
firebase.initializeApp(config)

// set all components to global component
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context('./components', false, /Base[A-Z]\w+\.(vue|js)$/)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1')))

  Vue.component(componentName, componentConfig.default || componentConfig)
})

Vue.config.productionTip = false

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
